export const CO_CHECK_DEBOUNCE_MS = 500;
